export const goTo = (uri) => {
    if (uri.indexOf('//') < 0) {
        uri = '//' + uri;
    }
    return window.open(uri);
};
